import { BriefingRequestSchema } from "@predoc/domain";
import { z } from "zod";

export const AiIntakeRequestSchema = z.object({
  situation: BriefingRequestSchema.shape.freeText.unwrap().min(1),
  aiConsent: z.literal(true),
}).strict();
export const aiCategoryLabels = { SYMPTOM: "증상·변화", ONSET: "발생 시점", MEDICATION: "복용약", ALLERGY: "알레르기", OTHER: "기타·함께 전달할 내용" } as const;
const CategorySchema = z.enum(["SYMPTOM", "ONSET", "MEDICATION", "ALLERGY", "OTHER"]);
export const AiAssignmentsSchema = z.object({ items: z.array(z.object({ id: z.number().int().min(0).max(29), category: CategorySchema }).strict()).min(1).max(30) }).strict();
export const AiDraftSchema = z.object({ items: z.array(z.object({ id: z.number().int().min(0).max(29), category: CategorySchema, text: z.string().min(1).max(500) }).strict()).min(1).max(30) }).strict();
export type AiDraft = z.infer<typeof AiDraftSchema>;

// Keep entire sentences, their order and all negations. The model can only
// assign labels to IDs; it cannot rewrite, omit or invent patient facts.
export function intakeSegments(situation: string): string[] {
  const parts = situation.trim().split(/(?<=[.!?。！？])\s+|\n+/u).map((part) => part.trim()).filter(Boolean);
  return parts.length > 30 ? [situation.trim()] : parts;
}
export function validateDraft(value: unknown, situation: string): AiDraft {
  const draft = AiDraftSchema.parse(value);
  const segments = intakeSegments(situation);
  if (draft.items.length !== segments.length || draft.items.some((item, index) => item.id !== index || item.text !== segments[index])) throw new Error("INVALID_AI_DRAFT");
  return draft;
}
export type AiErrorCode = "AI_UNAVAILABLE" | "AI_LIMIT_REACHED" | "AI_TIMEOUT" | "AI_INVALID_RESPONSE";
export class AiError extends Error {
  constructor(public readonly code: AiErrorCode) { super(code); }
}
export interface IntakeAssistant { organize(situation: string, signal?: AbortSignal): Promise<AiDraft>; }
